import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { MARKETING_SERVICES } from "@/data/site";
import { serif, mont, COLORS, es } from "./ui";

const V2Marketing = () => {
  return (
    <div data-testid="v2-marketing">
      <section className="max-w-6xl mx-auto px-6 pt-10 pb-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] mb-5" style={{ ...mont, color: COLORS.green, fontWeight: 600 }}>Marketing · Comunicación · Eventos</p>
          <h1 className="text-5xl sm:text-6xl font-light leading-[1]" style={serif}>Datos que generan negocio</h1>
          <p className="mt-7 text-lg leading-relaxed max-w-2xl" style={{ color: COLORS.sec }}>
            Estrategia, comunicación digital, eventos y fidelización con una obsesión: el resultado medible.
            Convertimos objetivos de negocio en acciones que las personas recuerdan y recomiendan.
          </p>
        </Reveal>
      </section>

      <section className="max-w-6xl mx-auto px-6 pb-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-8" style={{ borderTop: `1px solid ${COLORS.border}`, paddingTop: "3rem" }}>
        {MARKETING_SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={(i % 3) * 0.08}>
            <div className="bg-white h-full" style={{ border: `1px solid ${COLORS.border}` }}>
              <div className="overflow-hidden aspect-[16/10]">
                <img src={s.image} alt={es(s.title)} className="w-full h-full object-cover" />
              </div>
              <div className="p-7">
                <h3 className="text-2xl font-normal" style={serif}>{es(s.title)}</h3>
                <p className="mt-3 text-sm leading-relaxed" style={{ color: COLORS.sec }}>{es(s.desc)}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      {/* Eventos & Gastronomía band */}
      <section className="py-20" style={{ backgroundColor: COLORS.ink, color: "#FBF9F5" }}>
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] mb-5" style={{ ...mont, color: COLORS.gold, fontWeight: 600 }}>Eventos & Gastronomía</p>
            <h2 className="text-4xl font-light leading-tight" style={serif}>Experiencias de marca que se saborean</h2>
            <p className="mt-5 text-base leading-relaxed max-w-md" style={{ color: "rgba(251,249,245,0.7)" }}>
              Galas, jornadas y activaciones; catas, maridajes y experiencias gastronómicas para marcas de vino,
              bebidas y lifestyle premium. Del concepto a la producción integral.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {["Eventos & galas", "Activaciones", "Catas & maridajes", "Lifestyle premium"].map((t) => (
              <div key={t} className="p-5 text-sm" style={{ border: "1px solid rgba(251,249,245,0.18)", ...mont }}>{t}</div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 py-20 text-center">
        <h2 className="text-4xl font-light" style={serif}>¿Lo hablamos?</h2>
        <Link to="/v2/contacto" className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 text-xs font-bold uppercase tracking-[0.14em]" style={{ ...mont, backgroundColor: COLORS.ink, color: "#FBF9F5" }}>Contacto <ArrowRight size={15} /></Link>
      </section>
    </div>
  );
};

export default V2Marketing;
